import { DeliveryState } from "../../../type/delivery-state";

export const clearDisplayDeliveriesDispatch = (state: DeliveryState) => {
  state.displayDeliveries = [];
};
